interface BaseMFAFactor {
  id: string
  type: MFAFactorType
  status: string
  default: boolean
  createdAt: string
  updatedAt: string
}

export interface SMSMFAFactor extends BaseMFAFactor {
  type: 'sms'
  phoneNumber: string
}

export interface TOTPMFAFactor extends BaseMFAFactor {
  type: 'totp'
  secret?: string
  uri?: string
}

export interface MFAStatusRequest {
  userIds: string[]
}

export interface MFAStatus {
  userId: string
  status: string
}

export interface MFAFactorVerifyResponse {
  recoveryCodes: string[]
}

interface BaseMFAFactorCreateRequest {
  type: string
}

export interface SMSMFAFactorCreateRequest extends BaseMFAFactorCreateRequest {
  type: 'sms'
  phoneNumber: string
}

export interface TOTPMFAFactorCreateRequest extends BaseMFAFactorCreateRequest {
  type: 'totp'
}

export interface MFAChallengeResponseFactor {
  factorId: string
  code: string
}

export interface MFAChallengeResponseRecovery {
  recoveryCode: string
}

export type MFAChallengeResponse = MFAChallengeResponseFactor | MFAChallengeResponseRecovery

export interface SMSMFAFactorUpdateRequest {
  phoneNumber: string
}

export interface MFAFactorUpdateRequest {
  update: SMSMFAFactorUpdateRequest
  challengeResponse: MFAChallengeResponse
}

export type MFAFactorCreateRequest = SMSMFAFactorCreateRequest | TOTPMFAFactorCreateRequest

export interface MFAFactorCreateRequestWithChallengeResponse {
  factor: MFAFactorCreateRequest
  challengeResponse?: MFAChallengeResponse
}

export interface MFAConfig {
  mfaEnforced: boolean
  enterpriseEnforced: boolean
}

export interface MFAConfigUpdate {
  mfaEnforced: boolean
}

export type MFAFactor = SMSMFAFactor | TOTPMFAFactor
export type MFAFactorType = 'sms' | 'totp'

export enum MFAModalPageIdentifier {
  LOADING,
  SETUP,
  SETUP_SMS,
  SETUP_SMS_CODE,
  SETUP_TOTP,
  SETUP_TOTP_SCAN,
  SETUP_TOTP_CODE,
  SETUP_COMPLETE,
  CLAIM_MFA_CHOICE,
  CLAIM_SMS_CODE,
  CLAIM_TOTP,
  CLAIM_RECOVERY_CODE,
  CREATE_FACTOR,
  DELETE_FACTOR,
}
